import { CONTEXT_FIELD_RESOLVE_TO_RESOURCE, FieldDefinition } from '../../../../../shared/components/AdvancedExpressionBuilder/types';

export const NATIVE_FIELDS: FieldDefinition[] = [
  { identifier: 'id', label: 'ID', fieldType: 'text' },
  { identifier: 'identifier', label: 'Identifier', fieldType: 'text' },
  { identifier: 'name', label: 'Nome', fieldType: 'text' },
  { identifier: 'dueDatetime', label: 'Validade', fieldType: 'date' },
  { identifier: 'createdAt', label: 'Criado em', fieldType: 'date' },
  { identifier: 'financialValue', label: 'Valor Financeiro', fieldType: 'currency' },
  { identifier: 'assignedUserEmail', label: 'Email do usuário atribuído', fieldType: 'text' },
  { identifier: 'authorUserEmail', label: 'Email do autor', fieldType: 'text' },
  { identifier: 'relatedCustomerName', label: 'Nome do cliente relacionado', fieldType: 'text' },
  { identifier: 'relatedCustomerGovRegCode', label: 'Código de Registro do Cliente Relacionado', fieldType: 'text' },
  { identifier: 'lastCreditLimitExecutionScore', label: 'Última execução de limite de crédito', fieldType: 'numeric' },
  { identifier: 'lastCreditLimitExecutionScoreGrade', label: 'Última execução de limite de crédito', fieldType: 'numeric' },
  { identifier: 'lastCreditLimitExecutionSuggestedLimit', label: 'Limite de crédito sugerido', fieldType: 'currency' },
  { identifier: 'lastTransitionToPhaseName', label: 'Fase atual', fieldType: 'text' },
  { identifier: 'workflowName', label: 'Nome do workflow', fieldType: 'text' },
  { identifier: 'lastApprovalPhaseName', label: 'Última aprovação', fieldType: 'text' },
  { identifier: 'lastApprovalTotalValue', label: 'Valor total da última aprovação', fieldType: 'currency' },
  { identifier: 'lastApprovalType', label: 'Tipo de aprovação', fieldType: 'text' },
  { identifier: 'collateralAssets', label: 'Ativos de garantia', fieldType: 'text' },
  { identifier: 'totalCollateralAssetsFinancialValue', label: 'Valor total de ativos de garantia', fieldType: 'currency' },
  { identifier: 'organizationBranchId', label: 'Filial', fieldType: 'select', resolveToResourceId: CONTEXT_FIELD_RESOLVE_TO_RESOURCE.ORGANIZATION_BRANCH },
  { identifier: 'seasonIntervalId', label: 'Safra', fieldType: 'select', resolveToResourceId: CONTEXT_FIELD_RESOLVE_TO_RESOURCE.SEASON_INTERVAL },
];

export const SORT_ATTRIBUTES = [
  { value: 'createdAt', label: 'Data de Criação' },
  { value: 'ticketTransitionCreatedAt', label: 'Data de Transição' },
  { value: 'identifier', label: 'Identifier' },
];
